import { useEffect, useState } from "react"

export function useStickyHeaderClassName() {
  const [visible, setVisible] = useState(true)

  useEffect(() => {
    let lastScrollY = window.scrollY

    const handleScroll = () => {
      const currentScrollY = window.scrollY

      // When at the top, header should not be sticky
      if (currentScrollY <= 0) {
        setVisible(true)
        lastScrollY = currentScrollY
        return
      }

      // Scrolling down = sticky, scrolling up = not sticky
      setVisible(currentScrollY < lastScrollY)

      // Update last scroll position
      lastScrollY = currentScrollY
    }

    // Add scroll event listener
    window.addEventListener("scroll", handleScroll, { passive: true })

    // Initial check
    handleScroll()

    // Clean up
    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  const scrollClassName = [
    "z-sticky-header fixed top-0 transition-transform duration-300",
    visible ? "translate-y-0" : "-translate-y-full",
  ].join(" ")

  return scrollClassName
}
